import { useQuery } from '@tanstack/react-query';
import { getLeadPipelineStages } from '../api/leadPipelineStages';

export function useLeadPipelineStages() {
  return useQuery({
    queryKey: ['settings-lead-pipeline-stages'],
    queryFn: getLeadPipelineStages,
  });
}
